module.exports = __webpack_public_path__ + "media/combosmash-gameplay@lg-b28078944cb3a05483bfd82a15f0f47f.gif";